export default {
  heading: {
    title:
      "<span>You’re you.</span> Colleague, friend, child, sibling, partner, parent. <span>Person.</span>",
    subtitle: "We respect and support your truth. All are welcome here.",
    description:
      "Transgender and nonbinary people face tremendous challenges and barriers that include stigma, harassment, discrimination, violence and limited access to healthcare. In fact, 81% of transgender adults report they have considered suicide in the last year, compared to 4 percent of the overall U.S. population.<sup>1, 2</sup> Please know support and help are available.",
    pdf: "/assets/pdf/P365+_Transgender_Support.pdf",
  },
  transFamiliesSublabel: "Transfamilies.org",
  transFamiliesTitle: "Trans families resources and services",
  transFamiliesLink: "https://transfamilies.org/",
  transFamiliesDescription:
    "Trans families inspires hope, increases understanding and creates a visible pathway to support trans and gender-diverse children and all those who touch their lives.",
  transFamiliesImage: {
    src: require("@assets/images/toolkits/transfam.png"),
    width: 582,
    height: 322,
  },
  tips: "Tips for allies of transgender people",
  tipsDescription:
    "When you become an ally of transgender people, your actions will help change the culture, making society a better, safer place for transgender people and for all people (trans or not) who don’t conform to conventional gender expectations.",
  learnMore: "Learn more",
  learnMoreLink: "https://www.glaad.org/transgender/allies",
};
